package com.isaias.fyattravel.web.pages.settings
 
import androidx.compose.runtime.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import com.isaias.fyattravel.web.i18n.WebLocale
import com.isaias.fyattravel.web.i18n.WebLocaleStore
import com.isaias.fyattravel.web.i18n.WebStringKey
import com.isaias.fyattravel.web.i18n.WebStrings
import com.isaias.fyattravel.web.theme.ThemeColors
 
@Composable
fun LanguagePage() {
    val currentLocale = WebLocaleStore.locale.value
    var selectedLocale by remember(currentLocale) { mutableStateOf(currentLocale) }
    val isRtl = WebLocaleStore.isRtl(currentLocale)
 
    Div({
        style {
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            gap(1.25.em)
            property("text-align", if (isRtl) "right" else "left")
        }
    }) {
        Div({
            style {
                padding(1.25.em)
                borderRadius(1.em)
                backgroundColor(ThemeColors.surface)
                property("border", "1px solid ${ThemeColors.divider}")
                property("box-shadow", "0 10px 24px rgba(0,0,0,0.06)")
            }
        }) {
            H1({
                style {
                    margin(0.px, 0.px, 0.4.em, 0.px)
                    fontSize(2.em)
                    fontWeight("900")
                    color(ThemeColors.textPrimary)
                }
            }) { Text(WebStrings.t(WebStringKey.SELECT_LANGUAGE_TITLE)) }
 
            P({
                style {
                    margin(0.px)
                    color(ThemeColors.textMuted)
                    fontSize(1.em)
                }
            }) { Text(WebStrings.t(WebStringKey.CHOOSE_PREFERRED_LANGUAGE)) }
        }
 
        Div({
            style {
                display(DisplayStyle.Grid)
                property("grid-template-columns", "repeat(auto-fit, minmax(240px, 1fr))")
                gap(1.em)
            }
        }) {
            WebLocale.values().forEach { locale ->
                val isSelected = locale == selectedLocale
                Div({
                    style {
                        padding(1.em)
                        borderRadius(1.em)
                        backgroundColor(if (isSelected) ThemeColors.primaryMuted else ThemeColors.surface)
                        property("border", if (isSelected) "2px solid ${ThemeColors.primary}" else "1px solid ${ThemeColors.textPrimary}")
                        property("box-shadow", "0 10px 24px rgba(0,0,0,0.05)")
                        cursor("pointer")
                    }
                    onClick { selectedLocale = locale }
                }) {
                    Div({
                        style {
                            fontWeight("800")
                            color(ThemeColors.textPrimary)
                            fontSize(1.05.em)
                        }
                    }) { Text(locale.nativeName) }
                    Div({
                        style {
                            marginTop(0.35.em)
                            color(ThemeColors.textMuted)
                        }
                    }) {
                        val label = when (locale) {
                            WebLocale.EN -> WebStrings.t(WebStringKey.ENGLISH)
                            WebLocale.AM -> WebStrings.t(WebStringKey.AMHARIC)
                            WebLocale.AR -> WebStrings.t(WebStringKey.ARABIC)
                            WebLocale.SO -> WebStrings.t(WebStringKey.SOMALI)
                            WebLocale.SW -> WebStrings.t(WebStringKey.KISWAHILI)
                            WebLocale.TI -> WebStrings.t(WebStringKey.TIGRINYA)
                        }
                        Text(label)
                    }
 
                    if (isSelected) {
                        Div({
                            style {
                                marginTop(0.6.em)
                                color(ThemeColors.primary)
                                fontWeight("700")
                            }
                        }) { Text(WebStrings.t(WebStringKey.SELECTED)) }
                    }
                }
            }
        }
 
        Div({
            style {
                display(DisplayStyle.Flex)
                alignItems(AlignItems.Center)
                justifyContent(JustifyContent.SpaceBetween)
                gap(1.em)
                padding(1.em)
                borderRadius(1.em)
                backgroundColor(ThemeColors.surface)
                property("border", "1px solid ${ThemeColors.divider}")
            }
        }) {
            Div {
                Div({ style { fontWeight("700"); color(ThemeColors.textPrimary) } }) {
                    Text(WebStrings.t(WebStringKey.LANGUAGE))
                }
                Div({ style { color(ThemeColors.textMuted) } }) {
                    Text("${currentLocale.nativeName} (${currentLocale.displayName})")
                }
            }
 
            Button(attrs = {
                style {
                    backgroundColor(ThemeColors.primary)
                    color(ThemeColors.textOnGold)
                    borderRadius(0.9.em)
                    padding(0.7.em, 1.2.em)
                    property("border", "none")
                    fontWeight("800")
                    cursor("pointer")
                }
                onClick { WebLocaleStore.setLocale(selectedLocale) }
            }) { Text(WebStrings.t(WebStringKey.APPLY_LANGUAGE)) }
        }
    }
}
